import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ZipFileComponent} from './zip-file.component';


export const zipFileRoutes: Routes = [
  {
    path: 'zipFile',
    component: ZipFileComponent,
    data: {
      'expectedRoles': ['Accountant Admin', 'IT', 'Accountant']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(zipFileRoutes)],
  exports: [RouterModule]
})
export class ZipFileRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file-routing.module.ts